<template>
  <div class="order-action">
    <!--列表页action-->
    <div class="list-action border1px" v-if="type === 'list'">
      <div class="price">
        <span class="label">{{ priceMap.label }}：</span>
        <!-- 金额区域 -->
        <span class="no-high">
          <span class="fu-hao fs-36">￥</span>
          <span class="money fs-54">{{ priceMap.value.toFixed(2).split('.')[0] }}</span>
          <span class="decimal fs-36">{{ '.' + priceMap.value.toFixed(2).split('.')[1] }}</span>
        </span>
        <v-price-cut-icon
          v-if="unBalancePayment && orderBase.tailReduceAmt"
          :title="`已降价￥${orderBase.tailReduceAmt}`"
        ></v-price-cut-icon>
        <span class="djq-sm" v-if="orderBase.cashCoupon" @click="showCashPop"></span>
      </div>
      <div class="combine" v-if="priceMap.isShowCombine">
        （应付总额：¥{{ orderCombinedPayment.payTotalAmt }}&nbsp;&nbsp;&nbsp;已支付：¥{{
          orderCombinedPayment.cashAmt
        }}）
      </div>
      <div :class="['action', 'action-' + (normalAction.length + highAction.length)]">
        <v-button
          class="action-button"
          :disabled="!item.enable"
          size="medium"
          type="frame"
          lineColor="#E8E8E8"
          color="#000"
          :key="item.code"
          v-for="item in normalAction"
          @click="processOrder(item.code, item.enable, item)"
          v-track="btnTrack(item)"
        >
          {{ item.desc }}
        </v-button>
        <v-button
          class="action-button"
          :disabled="!item.enable"
          size="medium"
          :key="item.code"
          v-for="item in highAction"
          @click="processOrder(item.code, item.enable, item)"
          v-track="btnTrack(item)"
        >
          {{ item.desc }}
        </v-button>
      </div>
    </div>
    <!-- 待评价列表页商品行action -->
    <div class="order-item-actions" v-else-if="type === 'comment' && showRemarkBtn">
      <v-button
        class="comment-button"
        :disabled="!item.enable"
        size="medium"
        v-for="(item, key) in commentButton"
        :key="key"
        @click="processOrder(item.code, item.enable, item)"
        v-track="btnTrack(item)"
      >
        {{ item.desc }}
      </v-button>
    </div>
    <!--详情页订单行action-->
    <div v-if="type == 'detail-bottom' && (normalActionDetail.length > 0 || highAction.length > 0)" :class="['detail-action', 'border1px']" >
      <div class="price fs-36">
        <div v-if="isShowPrice">
          {{ priceMap.label }}:&nbsp;
          <span :class="{ colorPrice: isHighColor }" class="fs-54">
            <span class="label fs-36">¥</span>
            <v-price-animate
              :oldPrice="`${
                unBalancePayment && orderBase.tailReduceAmt ? priceMap.value + orderBase.tailReduceAmt : priceMap.value
              }`"
              :newPrice="priceMap.value"
              :itemClass="priceItemClass"
            ></v-price-animate>
          </span>
        </div>
      </div>
      <div class="action">
        <div class="normal" v-if="normalActionDetail.length > 0">
          <v-button
            class="detail-button"
            type="frame"
            lineColor="#E8E8E8"
            color="#000"
            :disabled="!item.enable"
            size="medium"
            v-for="(item, key) in normalActionDetail"
            :key="key"
            @click="processOrder(item.code, item.enable, item)"
            v-track="btnTrack(item)"
          >
            {{ item.desc }}
          </v-button>
        </div>
        <div class="high" v-if="highAction.length > 0">
          <v-button
            class="detail-button"
            :disabled="!item.enable"
            size="medium"
            v-for="(item, key) in highAction"
            :key="key"
            @click="processOrder(item.code, item.enable, item)"
            v-track="btnTrack(item)"
          >
            {{ item.desc }}
          </v-button>
        </div>
      </div>
    </div>
    <!-- 详情页单个商品行action -->
    <div v-if="type === 'detail'" class="sole-action">
      <div class="normal" v-if="productAction.length > 0">
        <v-button
          hairline
          class="sole-normal-btn"
          size="medium"
          round
          type="frame"
          lineColor="#E8E8E8"
          color="#000"
          :disabled="!item.enable"
          v-for="(item, key) in productAction"
          :key="key"
          @click.native.stop="processOrder(item.code, item.enable)"
          v-track="
            item.code === 'apply_refund'
              ? {
                  act: 'show',
                  params: {
                    cfrom: '114|003|02|077',
                    event_id: '114|003|02|077',
                    order_item_no: orderItemNo
                  }
                }
              : []
          "
        >
          <!-- 对售后单独进行处理 -->
          <span>{{ item.code === 'apply_refund' ? '售后/维修' : item.desc }}</span>
        </v-button>
      </div>
      <div class="high" v-if="productActionHign.length > 0">
        <v-button
          class="sole-normal-btn"
          :disabled="!item.enable"
          size="medium"
          v-for="(item, key) in productActionHign"
          :key="key"
          @click="processOrder(item.code, item.enable, item)"
          v-track="btnTrack(item)"
        >
          {{ item.desc }}
        </v-button>
      </div>
    </div>
    <v-share
      :shareType="shareType"
      :show="showShare"
      @close="showShare = false"
      :shareParams="shareParams"
      :posterParams="getPosterUrlParams()"
      v-if="showShare"
    ></v-share>
  </div>
</template>

<script>
import popup from '../order-refund-popup'
import shop from 'utils/shop'
import app from 'utils/app'
import API from 'api'
import { dealPayData } from 'utils/common'
import { statusToDes, statusCons } from '../../constant'
import {
  getSettleReq,
  getExpressReq,
  getReceiptReq,
  checkRefundApplyReq,
  remindShip,
  extendedDelivery
} from '../../api'
import clientEnv from '@/utils/clientEnv'
import { getGroupOnShareLinkApi, getGroupOnSharePosterApi } from 'views/groupon/detail/api'
export default {
  name: 'OrderAction',
  props: {
    type: String,
    actions: Array,
    orderItemNo: String,
    refundNo: String,
    orderNo: String,
    cancelReasonList: Array, // 取消订单原因
    offlineCancelReasonList: Array, // vivo+取消原因
    pureRefundReasonList: Array, // 退款原因
    refundReasonList: Array, // 退货原因
    orderDepositPresaleList: Array,
    orderCombinedPayment: Object,
    orderBase: Object,
    expressPkgNo: String,
    orderCommodityUnits: Array,
    cashPopCallback: Function,
    extData: Object,
    tabId: Number,
    showAddCartOption: Boolean, // 是否允许加购,
    orderRenewVO: Object // 是否换新订单
  },
  data: function () {
    return {
      dealSettleFlag: 0, // 防止重复点击支付按钮
      statusToDes,
      tempTerminal:
        this.$route.query.tempTerminal == '0' || this.$route.query.tempTerminal == '1'
          ? Number.parseInt(this.$route.query.tempTerminal)
          : -1,
      shareType: clientEnv.isVivoApp && clientEnv.appVersion >= 2400 ? 1 : 2, // 分享类型 1：native，2:h5
      showShare: false, // 是否唤起分享弹层
      shareParams: {},
      actionsList: this.actions
    }
  },
  watch: {
    actions: {
      deep: true,
      handler(newValue) {
        this.actionsList = newValue
      }
    }
  },
  computed: {
    isClosed() {
      const stausValue = this.statusToDes[this.orderBase.status].value
      return stausValue === 'closed'
    },
    normalAction() {
      let deleteItem = null
      for (const item of this.actionsList) {
        if (item.code == 'delete') {
          deleteItem = item
          break
        }
      }
      let arr1 = this.actionsList.filter(
        item =>
          item.type === 'normal' &&
          item.code !== 'delete' &&
          item.code !== 'refund_apply' &&
          item.code !== 'user_pure_refund_apply' &&
          item.code !== 'user_refund_goods_apply' &&
          item.code !== 'user_batch_refund_goods' &&
          item.code !== 'user_pure_refund_detail' &&
          item.code !== 'user_pure_refund_fail' &&
          item.code !== 'user_pure_refund_success' && // 退款成功按钮（在详情页展示）
          item.code !== 'user_contact_seller' // 列表页不展示联系导购
      )
      if (deleteItem) {
        arr1.unshift(deleteItem)
      }
      // 已完成订单去除查看物流按钮
      if (statusCons.S_COMPLETED_00 == this.orderBase.status) {
        arr1 = arr1.filter(item => item.code != 'view_logistics')
      }

      // 订单列表只要是四个场景， 就默认去掉拼团详情按钮
      if (arr1.length == 3 && this.highAction.length == 1)
        return arr1.filter(item => item.code != 'user_groupon_detail')
      else return arr1
    },
    // 详情页正常操作列表
    normalActionDetail() {
      let deleteItem = null
      for (const item of this.actionsList) {
        if (item.code == 'delete') {
          deleteItem = item
          break
        }
      }
      let arr1 = this.actionsList.filter(
        item =>
          item.type === 'normal' &&
          item.code !== 'delete' &&
          item.code !== 'view_logistics' &&
          item.code !== 'refund_goods' &&
          item.code !== 'refund_goods_detail' &&
          item.code !== 'refund_goods_fail' &&
          item.code !== 'refund_goods_success' &&
          item.code !== 'apply_refund' &&
          item.code !== 'user_modify_order_address' &&
          item.code !== 'user_contact_seller' // 966联系导购按钮隐藏，展示在商品栏
      )
      if (deleteItem) {
        arr1.unshift(deleteItem)
      }
      // 订单列表只要是四个场景， 就默认去掉拼团详情按钮
      if (arr1.length == 3 && this.highAction.length == 1)
        return arr1.filter(item => item.code != 'user_groupon_detail')
      else return arr1
    },
    highAction() {
      return this.actionsList.filter(item => item.type === 'high_light')
    },
    productAction() {//商品行普通按钮类型
      return this.actionsList.filter(
        item =>
          item.code === 'refund_goods' ||
          item.code === 'refund_goods_detail' ||
          item.code === 'refund_goods_fail' ||
          item.code === 'refund_goods_success' ||
          item.code === 'apply_refund' ||
          item.code === 'view_book_record'
      )
    },
    productActionHign() {//商品行high_light按钮类型
      return this.actionsList.filter(
        item => item.type === 'high_light' ?
          (item.code === 'comment_reward' || item.code === 'comment') && !this.showRemarkBtn ? false : true//商品行评价按钮8560客户端版本不展示，其他按钮code直接红色展示
          : false
      )
    },
    //过滤订单列表待评价tab评价按钮
    commentButton() {
      const res = this.actionsList.filter(item => item.code === 'comment_reward' || item.code === 'comment')
      return res
    },
    isShowPrice() {
      const { orderBase } = this
      return orderBase.status === '01'
    },
    isHighColor() {
      const { orderBase } = this
      return orderBase.status === '01'
    },
    statusNumber() {
      if (this.$route.query.status == 'to_comment') return 3
      else if (this.$route.query.status == 'completed') return 4
    },
    finishPayDeposit() {
      return (
        this.orderDepositPresaleList[0].stageStatusCode == '04' ||
        this.orderDepositPresaleList[0].stageStatusCode == '05' ||
        this.orderDepositPresaleList[0].stageStatusCode == '06'
      )
    },
    priceMap() {
      const { orderDepositPresaleList, orderBase, orderCombinedPayment } = this
      const { payStatus, actPaidAmount, tailReduceAmt, status } = orderBase
      if (orderDepositPresaleList) {
        if (this.finishPayDeposit) {
          if (status == statusCons.S_REFUNDED_81) {
            // 退定金成功状态
            return {
              label: '实付金额',
              value: orderDepositPresaleList[0].paymentPrice + orderDepositPresaleList[0].cashCoupon
            }
          }
          if (this.unBalancePayment && tailReduceAmt) {
            return {
              isColorPrice: true,
              label: '应付尾款',
              value:
                orderDepositPresaleList[1].paymentPrice - tailReduceAmt >= 0
                  ? orderDepositPresaleList[1].paymentPrice - tailReduceAmt
                  : 0
            }
          } else {
            return {
              isColorPrice: true,
              label: '应付尾款',
              value: orderDepositPresaleList[1].paymentPrice
            }
          }
        } else {
          return {
            isColorPrice: true,
            label: '应付定金',
            value: orderDepositPresaleList[0].paymentPrice + orderDepositPresaleList[0].cashCoupon
          }
        }
      } else if (!this.isClosed && orderCombinedPayment && orderCombinedPayment.payResult === 'partial') {
        return {
          isShowCombine: true,
          isColorPrice: true,
          label: '还应支付',
          value: orderCombinedPayment.normalPayAmt
        }
      } else {
        // 已完成 已关闭 金额颜色是黑色
        if (payStatus === '00' || payStatus === '09') {
          return {
            label: '实付金额',
            value: actPaidAmount
          }
        } else {
          return {
            label: '应付金额',
            isColorPrice: false,
            value: actPaidAmount
          }
        }
      }
    },
    unBalancePayment() {
      return (
        this.orderDepositPresaleList?.length &&
        this.finishPayDeposit &&
        (this.orderDepositPresaleList[1]?.stageStatusCode === '01' ||
          this.orderDepositPresaleList[1]?.stageStatusCode === '02')
      )
    },
    isDepositRefunding() {
      return this.orderDepositPresaleList[0]?.stageStatusCode == '05'
    },
    disabledModifyAdress() {
      const actionsList = this.actionsList || []
      const modifyAdress = actionsList.find(opt => opt.code === 'user_modify_order_address')
      return (modifyAdress && !modifyAdress.enable) || false
    },
    showRemarkBtn() {
      const lessThan = true
      return clientEnv.appVersion == 8560 || clientEnv.appVersion == 8561 || !app.checkVersion(8600, lessThan) || clientEnv.isIOSVivoApp
    }
  },
  beforeDestroy() {
    popup.close()
  },
  mounted() {
    const { type } = this
    if (type != 'list') {
      // 详情页 邀请好友 曝光
      if (this.highAction.findIndex(item => item.code == 'user_groupon_invite') > -1) {
        API.logAll({
          cfrom: '114|002|02|077',
          event_id: '114|002|02|077',
          order_num: this.orderNo,
          module: this.orderBase.grouponType ? 2 : 1,
          taskType: 2
        })
      }
    }
  },
  methods: {
    processOrder(type, enable, item) {
      // 按钮点击埋点
      this.btnTrackClick(type)
      // 取消订单
      if (type === 'cancel') {
        // 取消订单订单类型，vivo+订单取消原因不同
        let deliveryMode = this.orderBase.offlineOrderInfo?.deliveryMode
        let isVivoPlus = deliveryMode === 2 || deliveryMode === 3
        this.dealCancel(isVivoPlus)
      } else if (
        type === 'settle' ||
        type === 'pay_deposit' ||
        type === 'tail_payment' ||
        type === 'user_continue_pay' ||
        type == 'user_continue_pay'
      ) {
        if (type == 'tail_payment' && !enable) {
          // 定金退款中
          if (this.isDepositRefunding) {
            this.$toast('订单退定金中')
          } else {
            this.$toast('支付尾款时间未到')
          }
        } else {
          // 去结算
          this.dealSettle()
        }
      } else if (type === 'refund_apply' || type === 'refund_detail') {
        // 退款/退货
        this.dealRefund(type === 'refund_detail')
      } else if (type === 'view_logistics') {
        // 查看物流
        this.dealLogistics()
      } else if (type === 'confirm_receipt') {
        // 确认收货
        this.dealReceipt()
      } else if (type === 'comment' || type === 'comment_reward' || type === 'comment_merge') {
        const orderItemNo = type === 'comment_merge' ? undefined : this.orderItemNo
        // 去评价
        this.dealComment(orderItemNo)
      } else if (type === 'user_groupon_invite') {
        // 邀请好友
        this.getShareInfo()
      } else if (type === 'user_groupon_detail') {
        // 拼团详情
        this.goToGroupOnDetail()
      } else if (type === 'user_modify_order_address') {
        // 修改地址
        if (enable) {
          this.dealAddress()
        } else {
          // 网易和IOT订单
          this.$toast('请联系客服修改地址')
        }
      } else if (type === 'user_remind_delivery') {
        // 提醒发货
        this.remindDelivery(item)
      } else if (
        // 新退款、退货
        type === 'user_pure_refund_apply' || // 退款
        type === 'user_pure_refund_detail' || // 退款详情
        type === 'user_pure_refund_success' || // 退款成功
        type === 'user_pure_refund_fail' || // 退款失败
        type === 'user_refund_goods_apply' || // 退货
        type === 'user_refund_goods_detail' || // 退货详情
        type === 'user_refund_goods_success' || // 退货成功
        type === 'user_refund_goods_fail' || // 退货失败
        type === 'user_batch_refund_goods' || // 批量退货
        type === 'refund_goods' || // 商品行退货
        type === 'refund_goods_detail' || // 商品行退货详情
        type === 'refund_goods_fail' || // 商品行退货失败
        type === 'refund_goods_success' // 商品行退货成功
      ) {
        // 退款退货
        this.dealPureRefund(type)
      } else if (type === 'apply_refund') {
        this.gotoRefundSelect()
      } else if (type === 'user_contact_seller') {
        // 联系导购按钮被隐藏
        // 导购配送联系导购
        this.$emit('action', {
          type: 'contactGuide',
          params: {
            orderNo: this.orderNo,
            status: this.orderBase.status,
            sellerCode: this.orderBase.offlineOrderInfo?.sellerCode
          }
        })
      } else if (type === 'user_query_pickup_pic') {
        // 导购配送，取货码
        this.$emit('action', {
          type: 'pickupQrcode',
          params: {
            orderNo: this.orderNo,
            status: this.orderBase.status
          }
        })
      } else if (type === 'delete' && item.type === 'normal') {
        this.$emit('deleteOrder')
      } else if (type === 'extend_receipt') {
        // 延长收货
        this.extendedDelivery()
      } else if (type === 'replace') {
        // 买了换钱
        this.sellProduct()
      } else if(type === 'user_book'){
        //售后服务
        this.$emit('bookService')
      } else if(type === 'view_book_record'){
         window.location.href = `${this.linkBase}/my/repair?orderNo=${this.orderNo}`
      }
    },
    // 以旧换新
    sellProduct() {
      window.location.href = 'https://shop.vivo.com.cn/wap/vs/recycle'
    },
    // 延长收货
    extendedDelivery() {
      this.$osDialog.confirm({
        title: '确认延长收货时间',
        content: '收货时间可延长3天，每笔订单只能延长一次',
        maskClosable: true,
        onConfirm: () => {
          const { orderNo } = this
          extendedDelivery({ orderNo }).then(
            res => {
              if (res && res.msg) {
                this.$toast(res.msg)
              } else {
                this.$toast('延长收货成功')
              }
              // 刷新页面
              this.refresh()
            },
            res => {
              if (res && res.msg) {
                this.$toast(res.msg)
              } else {
                this.$toast('延长收货失败，请稍后再试')
              }
            }
          )
        }
      })
    },
    // 修改地址
    dealAddress() {
      const { orderNo } = this
      let url = this.$route.fullPath
      let param = ''
      if (url.indexOf('addressId') === -1) {
        param = `&orderNo=${orderNo}`
      } else {
        param = `&orderNo=${orderNo}&addressId=${this.$route.query.addressId}`
      }
      let backUrl = encodeURIComponent(url) + param
      this.$router.push({
        path: '/my/address?backUrl=' + backUrl
      })
    },
    // 提醒发货
    remindDelivery(item) {
      const { orderNo } = this
      if (item.enable === 0) return
      remindShip({ orderNo }).then(res => {
        // 这里会报 vuex warning
        item.enable = 0
        item.desc = '已提醒发货'
        this.$toast('提醒发货成功，将尽快为您发货')
        // 如果是在订单详情，需要将状态同步到订单列表
        this.$emit('syncOrder')
      })
    },
    // 前往售后中间页
    gotoRefundSelect() {
      const { orderNo, refundNo, orderItemNo, tempTerminal } = this
      const url = `${this.linkBase}/my/refund/select`
      const query = `orderNo=${orderNo}&refundNo=${
        refundNo || ''
      }&orderItemNo=${orderItemNo}&tempTerminal=${tempTerminal}`
      API.logAll({
        cfrom: '114|003|01|077',
        event_id: '114|003|01|077',
        order_item_no: orderItemNo
      })
      // 让埋点请求发出去
      setTimeout(() => {
        this.$router.push({
          path: '/my/refund/select',
          query: {
            orderNo,
            refundNo: refundNo || '',
            orderItemNo,
            tempTerminal
          }
        })
        // window.location.href = `${url}?${query}`
      }, 100)
    },
    // 退款
    dealPureRefund(type) {
      // 新增vService参数，用于区分是否是从小v客服跳转过来，没有该参数则是从小v客服跳转
      const { orderNo, refundNo, orderItemNo, refundType } = this
      if (type === 'user_pure_refund_apply') {
        checkRefundApplyReq({ orderNo, tempTerminal: this.tempTerminal }).then(
          res => {
            if (res === 2) {
              this.$toast('当前版本暂不支持退款，请使用浏览器发起退款申请')
            } else {
              const { orderNo, orderBase } = this
              const { orderType } = orderBase
              const that = this
              popup({
                type: 'refund',
                tempTerminal: this.tempTerminal,
                reasonList: this.pureRefundReasonList,
                showAddCartOption: this.showAddCartOption,
                orderCommodityUnits: this.orderCommodityUnits,
                fullPath: this.$route.fullPath,
                orderNo,
                orderType,
                orderBase,
                disabledModifyAdress: this.disabledModifyAdress,
                orderRenewVO: this.orderRenewVO,
                routerFun: (type, param) => {
                  that.$router[type](param)
                },
                orderEv: () => {}
              })
            }
          },
          res => {
            if (res && res.msg) {
              this.$toast(res.msg)
            }
          }
        )
      } else if (type === 'user_refund_goods_apply' || type === 'user_batch_refund_goods' || type === 'refund_goods') {
        checkRefundApplyReq({ orderNo, tempTerminal: this.tempTerminal }).then(
          res => {
            if (res === 2) {
              this.$toast('当前版本暂不支持退货，请使用浏览器发起退货申请')
            } else {
              this.$router.push(
                '/my/refund/apply?orderNo=' +
                  orderNo +
                  '&refundNo=' +
                  refundNo +
                  '&orderItemNo=' +
                  orderItemNo +
                  '&refundType=2' +
                  '&tempTerminal=' +
                  this.tempTerminal +
                  '&vService=1'
              )
            }
          },
          res => {
            if (res && res.msg) {
              this.$toast(res.msg)
            }
          }
        )
      } else if (['user_pure_refund_success', 'user_pure_refund_detail'].includes(type)) {
        const url = `/my/refund/detail`
        const query = `orderNo=${orderNo}&refundNo=${refundNo}&orderItemNo=${orderItemNo}&tempTerminal=${this.tempTerminal}`
        this.$router.push(`${url}?${query}`)
      } else {
        const url = `${this.linkBase}/my/refund/detail`
        const query = `orderNo=${orderNo}&refundNo=${refundNo}&orderItemNo=${orderItemNo}&tempTerminal=${this.tempTerminal}`
        window.location.href = `${url}?${query}`
      }
    },
    dealCancel(isVivoPlus) {
      const { orderNo, orderBase } = this
      const { orderType } = orderBase
      const that = this
      popup({
        type: 'cancel',
        tempTerminal: this.tempTerminal,
        reasonList: isVivoPlus ? this.offlineCancelReasonList : this.cancelReasonList,
        showAddCartOption: this.showAddCartOption,
        orderCommodityUnits: this.orderCommodityUnits,
        fullPath: this.$route.fullPath,
        isList: this.type == 'list',
        orderNo,
        orderType,
        orderBase,
        orderRenewVO: this.orderRenewVO,
        routerFun: (type, param) => {
          that.$router[type](param)
        },
        orderEv: orderNo => {
          this.$emit('orderCancel', orderNo)
        }
      })
    },
    dealSettle() {
      const { orderNo, tempTerminal } = this
      if (this.dealSettleFlag) {
        return
      }
      this.dealNFlag = 1
      setTimeout(() => {
        this.dealNFlag = 0
      }, 500)
      getSettleReq({
        orderNo,
        tempTerminal
      }).then(
        res => {
          dealPayData(res, this.type == 'list' ? 'orderList' : 'orderDetail', flag => {}, tempTerminal)
        },
        res => {
          if (res && res.msg) {
            this.$toast(res.msg)
            // 订单已被支付，刷新页面
            setTimeout(() => {
              location.reload()
            }, 3000)
          }
        }
      )
    },
    dealRefund(isDetail) {
      const { orderNo, refundNo, orderItemNo, refundType } = this
      if (isDetail) {
        this.$router.push(
          '/my/refund/detail?orderNo=' +
            orderNo +
            '&refundNo=' +
            refundNo +
            '&orderItemNo=' +
            orderItemNo +
            '&tempTerminal=' +
            this.tempTerminal
        )
      } else {
        checkRefundApplyReq({ orderNo, tempTerminal: this.tempTerminal }).then(
          res => {
            if (res === 2) {
              this.$toast('当前版本暂不支持退货，请使用浏览器发起退货申请')
            } else {
              const { orderNo, orderBase } = this
              const { orderType } = orderBase
              const that = this
              popup({
                type: 'refund',
                tempTerminal: this.tempTerminal,
                reasonList: this.pureRefundReasonList,
                showAddCartOption: this.showAddCartOption,
                orderCommodityUnits: this.orderCommodityUnits,
                fullPath: this.$route.fullPath,
                orderNo,
                orderType,
                orderBase,
                orderRenewVO: this.orderRenewVO,
                routerFun: (type, param) => {
                  that.$router[type](param)
                },
                orderEv: () => {}
              })
            }
          },
          res => {
            if (res && res.msg) {
              this.$toast(res.msg)
            }
          }
        )
      }
    },
    dealLogistics() {
      const { orderNo, tempTerminal } = this
      app.openNewWebview({
        url: `${this.linkBase}/my/order/expressInfo?orderNo=${orderNo}&tempTerminal=${tempTerminal}`
      })
    },
    dealReceipt() {
      const { orderNo, orderBase, expressPkgNo } = this
      const { orderType } = orderBase
      // 提交收货请求
      const deliveryGoods = () =>
        getReceiptReq({ orderNo, tempTerminal: this.tempTerminal }).then(
          () => {
            // 刷新页面
            this.refresh()
            // 将结果同步给订单列表页
            const payload = {
              orderNo,
              status: 'to_receive'
            }
            this.$store.commit('order-list/removeSingleOrder', payload, { root: true })
          },
          res => {
            if (res && res.msg) {
              this.$toast(res.msg)
            }
          }
        )
      this.$osDialog.confirm({
        content: '是否确认收货',
        onConfirm: () => {
          if (orderType === '02') {
            getExpressReq({
              orderNo,
              expressPkgNo,
              tempTerminal: this.tempTerminal
            }).then(
              res => {
                if (res) {
                  deliveryGoods()
                } else {
                  this.$osDialog.alert({
                    title: '温馨提示',
                    content: '该订单还未签收!',
                    confirmStyles: {
                      color: '#e90f23'
                    }
                  })
                }
              },
              res => {
                if (res && res.msg) {
                  this.$toast(res.msg)
                }
              }
            )
          } else {
            deliveryGoods()
          }
        }
      })
    },
    dealComment(orderItemNo) {
      if (this.dealNFlag) {
        return
      }
      this.dealNFlag = 1
      setTimeout(() => {
        this.dealNFlag = 0
      }, 500)
      let spuId =
        this.orderCommodityUnits && this.orderCommodityUnits.length
          ? this.orderCommodityUnits[0].orderCommodity.commoditySpuId
          : ''
      let self = this
      shop.checkRealName(
        passportHost => {
          let url =
            `/my/comment/unRemark-prod?source=remark&orderNo=${this.orderNo}&spuId=${spuId}&tempTerminal=${self.tempTerminal}&realNameRegister=1` +
            (orderItemNo ? `&orderItemNo=${orderItemNo}` : '')
          let redirectUri = window.location.protocol + '//' + window.location.host + this.linkBase + url
          shop.redirectCommon(
            redirectUri,
            passportHost + 'pass/account/center/main/realName?source=pc&client_id=3&redirect_uri='
          )
        },
        () => {
          window.location.href = `/wap/my/comment/unRemark-prod?orderNo=${self.orderNo}&tempTerminal=${self.tempTerminal}` +
              (orderItemNo ? `&orderItemNo=${orderItemNo}` : '')
        }
      )
    },
    // 刷新页面
    refresh() {
      this.$emit('refresh')
    },
    showCashPop() {
      this.cashPopCallback && this.cashPopCallback()
    },
    goToGroupOnDetail() {
      window.location.href = '/wap/groupon/detail?orderNo=' + this.orderBase.orderNo + '&page_source=2'
      // this.$router.push(`/groupon/detail?orderNo=${this.orderBase.orderNo}&page_source=2`)
    },
    // 获取分享信息
    async getShareInfo() {
      let query = {
        grouponId: this.extData.grouponId,
        skuId:
          this.orderCommodityUnits && this.orderCommodityUnits.length
            ? this.orderCommodityUnits[0].orderCommodity.commoditySkuId
            : ''
      }
      if (this.type == 'list') {
        API.logAll({
          cfrom: '101|004|01|077',
          event_id: '101|004|01|077',
          skuid: query.skuId,
          module: this.orderBase.grouponType ? 2 : 1,
          tab_id: this.statusNumber || 0
        })
      } else {
        API.logAll({
          cfrom: '114|002|01|077',
          event_id: '114|002|01|077',
          order_num: this.orderNo,
          module: this.orderBase.grouponType ? 2 : 1,
          taskType: 2
        })
      }
      try {
        const link = await getGroupOnShareLinkApi(query)
        // 唤起分享
        this.shareParams = {
          title: link.shareTitle,
          summary: link.shareDesc,
          sharedUrl: link.groupOnOrderDetailUrl,
          imageUrl: link.commodityImgUrl + '_white.jpg', // 获取白色背景图片，解决微信中透明图片展示黑底问题
          miniPath: `/pages/groupon/detail/index?grouponId=${query.grouponId}&skuId=${query.skuId}&page_source=3`,
          finishCallBack: 'shareFinish'
        }
        // 非app中只有海报分享，需要立即获取海报，app中在点击分享海报的时候才请求接口，减少服务器压力
        if (this.shareType == 2) {
          const poster = await getGroupOnSharePosterApi(query)
          if (poster) {
            this.shareParams.posterUrl = poster
            this.shareParams = Object.assign({}, this.shareParams)
          }
        }
        // 分享后回调
        window.shareFinish = function () {
          // 埋点
        }
        this.showShare = true
      } catch (err) {
        this.$toast(err.msg)
      }
    },
    // 获取海报接口请求参数
    getPosterUrlParams() {
      return {
        url: '/groupon/share/poster',
        params: {
          grouponId: this.extData.grouponId,
          skuId:
            this.orderCommodityUnits && this.orderCommodityUnits.length
              ? this.orderCommodityUnits[0].orderCommodity.commoditySkuId
              : ''
        }
      }
    },
    // 按钮点击埋点信息
    btnTrackClick(code) {
      let param = null
      if (this.type == 'list') {
        // 列表页按钮点击埋点
        if (code == 'replace') {
          // 买了换钱按钮点击埋点
          param = {
            cfrom: '101|009|01|077',
            event_id: '101|009|01|077'
          }
        } else if (code == 'view_logistics') {
          // 查看物流点击埋点
          param = {
            cfrom: '101|012|01|077',
            event_id: '101|012|01|077',
            order_id: this.orderNo
          }
        } else if (['comment_reward', 'comment', 'comment_merge'].includes(code)) {
          // 评价有礼、去评价、合并评价
          // 1:评价有礼 2:去评价 3:合并评价
          const button_name = code == 'comment_reward' ? 1 : code == 'comment_merge' ? 3 : 2
          param = {
            event_id: '101|002|01|077',
            button_name: button_name,
            taskType: 1,
            tab_id: 3
          }
        }
      } else if (this.type == 'comment') {
        // 1:评价有礼 2:去评价
        const button_name = code == 'comment_reward' ? 1 : 2
        param = {
          event_id: '101|002|01|077',
          button_name: button_name,
          tab_id: 3
        }
      } else {
        // 详情页按钮点击埋点
        if (code == 'replace') {
          // 买了换钱按钮点击埋点
          param = {
            cfrom: '084|009|01|077',
            event_id: '084|009|01|077'
          }
        }
      }
      if (param) {
        API.logAll(param)
      }
    },
    // 按钮曝光埋点
    btnTrack(item) {
      if (this.type == 'list') {
        // 列表页
        if (['user_contact_seller', 'user_query_pickup_pic'].includes(item.code)) {
          const ids = {
            user_contact_seller: '101|007|02|077',
            user_query_pickup_pic: '101|008|02|077'
          }
          return {
            act: 'show',
            params: {
              event_id: ids[item.code],
              tab_id: this.tabId,
              order_id: this.orderBase.orderNo,
              order_status: this.orderBase.status
            }
          }
        } else if ('replace' == item.code) {
          // 买了换钱按钮曝光
          return {
            act: 'show',
            params: {
              cfrom: '101|009|02|077',
              event_id: '101|009|02|077'
            }
          }
        } else if (item.code == 'view_logistics') {
          // 查看物流曝光埋点
          return {
            act: 'show',
            params: {
              cfrom: '101|012|02|077',
              event_id: '101|012|02|077',
              order_id: this.orderNo
            }
          }
        } else if (['comment_reward', 'comment', 'comment_merge'].includes(item.code)) {
          // 评价有礼、去评价、合并评价
          // 1:评价有礼 2:去评价 3:合并评价
          const button_name = item.code == 'comment_reward' ? 1 : item.code == 'comment_merge' ? 3 : 2
          return {
            act: 'show',
            params: {
              event_id: '101|002|02|077',
              button_name: button_name,
              tab_id: 3
            }
          }
        }
      } else if (this.type == 'comment') {
        // 1:评价有礼 2:去评价
        const button_name = item.code == 'comment_reward' ? 1 : 2
        return {
          act: 'show',
          params: {
            event_id: '101|002|02|077',
            button_name: button_name,
            tab_id: 3
          }
        }
      } else {
        // 详情页
        if (item.code == 'replace') {
          // 买了换钱按钮曝光
          return {
            act: 'show',
            params: {
              cfrom: '084|009|02|077',
              event_id: '084|009|02|077'
            }
          }
        }
      }
      return undefined
    },
    priceItemClass(arr, i) {
      let index = arr.findIndex(item => isNaN(item))
      if (index > i) {
        return 'fs-66'
      } else {
        return 'fs-36'
      }
    }
  }
}
</script>
<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss" scoped>
.vivo-fontscale-4 {
  .order-action .detail-action .action {
    margin-right: 24px;
  }
  .order-action .detail-action .normal .v-button,
  .order-action .detail-action .high .v-button {
    margin-left: 15px !important;
  }
}
.vivo-fontscale-5 {
  .order-action .detail-action .action {
    margin-right: 24px;
  }
  .order-action .detail-action .normal .v-button,
  .order-action .detail-action .high .v-button {
    margin-left: 12px !important;
    padding: 0 15px;
  }
}
</style>
